//@flow
import React, {useCallback} from 'react';
import {makeStyles} from '@material-ui/core';
import {useState} from 'react';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import {debounce} from '../../../../../utils/functions';
import {getImageUrl} from '../../../../../utils/image_provider';

import {useProductContext} from '../../../context';
import {useProductImage, useEditProduct} from '../../../utils/editProduct';
import ProductImagesModal from '../../../../../elements/ProductImagesModal';

const useStyles = makeStyles(theme => ({
  cell: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    minWidth: 'max-content',
  },
  productImageButton: {
    marginRight: '.5rem',
    width: '3rem',
    height: '3rem',
    borderRadius: '.5rem',
    overflow: 'hidden',
    cursor: 'pointer',
    padding: 0,
    margin: 0,
    border: 'none',
    background: 'none',
  },
  productImage: {
    width: '3rem',
    height: '3rem',
    borderRadius: '.5rem',
    overflow: 'hidden',
    cursor: 'pointer',
    marginRight: '.5rem',

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transition: 'transform .2s ease-in-out',
    },

    '&:hover img': {
      transform: 'scale(1.1)',
    },
  },
  textField: {
    width: '240px',
  },
}));

export default function ProductNameCell() {
  const classes = useStyles();

  const [product, setProduct] = useProductContext(product => ({
    id: product.id,
    name: product.name,
    images: product.images || [],
    mainImageId: product.mainImageId,
  }));

  const [posterImage, setPosterImage] = useState(
    getImageUrl(product.mainImageId)
  );

  const {editProduct} = useEditProduct(product ? product.id : '');
  const {loading, setPosterImage: setPosterImageService} = useProductImage();

  const [cropModalOpen, setCropModalOpen] = useState(false);

  const openCropModal = () => setCropModalOpen(true);
  const closeCropModal = () => setCropModalOpen(false);

  const handleChangeName = useCallback(
    debounce(name => {
      if (!name) return;
      if (name === product.name) return;

      setProduct({name});
      editProduct({name});
    }, 500),
    [editProduct]
  );

  const {images} = product;

  return (
    <>
      <button className={classes.productImageButton} onClick={openCropModal}>
        <picture className={classes.productImage}>
          <img src={posterImage} alt="product" />
        </picture>
      </button>
      <CustomTextField
        name="name"
        className={classes.textField}
        defaultValue={product.name}
        onChange={e => {
          const name = e.target.value.trim();
          handleChangeName(name);
        }}
        type="text"
      />
      <ProductImagesModal
        open={cropModalOpen}
        onClose={closeCropModal}
        loading={loading}
        canSelect
        canUpload
        selectOnUpload
        onSave={result => {
          if (!result.imageSelected) return;
          const {isNew, id, file} = result.imageSelected;

          if (!isNew && id) {
            setProduct({mainImageId: id});
            setPosterImage(getImageUrl(id));
            closeCropModal();
            setPosterImageService(id);
            return;
          }

          if (isNew && file) {
            setPosterImageService(file).then(id => {
              setProduct({mainImageId: id});
              setPosterImage(getImageUrl(id));
              closeCropModal();
            });
          }
        }}
        selectedLabel="PORTADA"
        images={images.map(({id}) => ({preview: getImageUrl(id), id}))}
        defaultSelected={posterImage}
      />
    </>
  );
}

// export default React.memo<Props>(ProductNameCell);
